export enum RoutePolicy {
  // route is visible to not authenticated users only
  ForGuests = "FOR_GUESTS",
  // route is visible to authenticated users only
  ForAuthenticated = "FOR_AUTHENTICATED",
  // route is visible to anyone, regardless of authentication status
  ForAnyone = "FOR_ANYONE",
}
